import React from "react";
import styles from "./WebFormBuilding.module.css";
import CustomizedProfilePicField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedProfilePicField";
import CustomizedTextField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedTextField";
import CustomizedPhoneField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedPhoneField";
import CustomizedEmailField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedEmailField";
import CustomizedCheckboxField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedCheckboxField";
import CustomizedDropdownField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedDropdownField";
import CustomizedRadioField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedRadioField";
import CustomizedDateField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedDateField";
import configureIcon from "../../../../../../assets/images/configureIcon.svg";
import { useNavigate } from "react-router-dom";
import CustomizedImageField from "../../../../Settings/components/Customize/Tabs/CustomizeTab/CustomizedField/CustomizedImageField";

function WebformFields(props: any) {
  const { defaultFields, customFields, handleOnDrag } = props;
  const navigate = useNavigate();

  const isNameUniqueCheck = (fieldName: any, fieldIndex: number) => {
    return !customFields?.some(
      (r: any) =>
        r?.index !== fieldIndex &&
        r?.fieldName?.toLowerCase() === fieldName?.toLowerCase()
    );
  };

  return (
    <div>
      <div className={styles.webformFieldsWrap}>
        <div className={styles.webformFieldsTitle}>Default Parameter</div>
        {defaultFields?.map((field: any, index: number) => (
          <div
            key={index}
            className={styles.primaryFields}
            draggable
            onDragStart={(e) => handleOnDrag(e, field)}
          >
            {field.fieldType === "text" && (
              <CustomizedTextField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "phone" && (
              <CustomizedPhoneField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "email" && (
              <CustomizedEmailField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}

            {field.fieldType === "checkbox" && (
              <CustomizedCheckboxField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "select" && (
              <CustomizedDropdownField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "radio" && (
              <CustomizedRadioField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "date" && (
              <CustomizedDateField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "file" && (
              <CustomizedProfilePicField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "profilePic" && (
              <CustomizedProfilePicField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {(field.fieldType === "COURSE" ||
              field.fieldType === "BRANCH" ||
              field.fieldType === "BATCH") && (
              <CustomizedDropdownField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
          </div>
        ))}
      </div>
      <div className={styles.webformFieldsWrap}>
        <div className={styles.webformFieldsTitle}>Custom Fields</div>
        {customFields?.map((field: any, index: number) => (
          <div
            key={index}
            className={styles.primaryFields}
            draggable
            onDragStart={(e) => handleOnDrag(e, field)}
          >
            {field.fieldType === "text" && (
              <CustomizedTextField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "phone" && (
              <CustomizedPhoneField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "email" && (
              <CustomizedEmailField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}

            {field.fieldType === "checkbox" && (
              <CustomizedCheckboxField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "select" && (
              <CustomizedDropdownField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "radio" && (
              <CustomizedRadioField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "date" && (
              <CustomizedDateField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "file" && (
              <CustomizedProfilePicField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "profilePic" && (
              <CustomizedProfilePicField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
              />
            )}
            {field.fieldType === "image" && (
              <CustomizedImageField
                field={field}
                onFieldChange={() => {}}
                onDelete={() => {}}
                edit={false}
                deleteAction={false}
                mandatory={false}
                isNameUniqueCheck={isNameUniqueCheck}
              />
            )}
          </div>
        ))}

        <div
          className={styles.configureBtn}
          onClick={() => navigate(`/app/Settings/Customize?tabOpen=parameter`)}
        >
          <img src={configureIcon} alt="icon" />
          Configure customizable parameter
        </div>
      </div>
    </div>
  );
}

export default WebformFields;
